
const TablaEquipamiento = ({ tablaData, tablaTotales }) => {
   return (
      <table className="table table-sm table-bordered text-xs elevation-2">
         <thead className="bg-gradient-light">
            <tr>
               <th rowSpan={2} className="text-center align-middle p-1">TIPO DE EQUIPAMIENTO</th>
               <th colSpan={6} className="text-center">ESTADO DEL EQUIPAMIENTO</th>
               <th rowSpan={2} className="text-center align-middle p-1">TOTAL</th>
            </tr>
            <tr className="text-center">
               <th className="pl-0 pr-0">OB</th>
               <th className="pl-0 pr-0">OR</th>
               <th className="pl-0 pr-0">OMR</th>
               <th className="pl-0 pr-0">OMB</th>
               <th className="pl-0 pr-0">IPR</th>
               <th className="pl-0 pr-0">IPB</th>

            </tr>
         </thead>
         <tbody>
            {
               tablaData.map(({ tipo_equipamiento, OB, OR, MPR, MPB, IPR, IPB, total }, index) =>
                  <tr key={index} className="text-right">
                     <td className="pl-1">{tipo_equipamiento}</td>
                     <td>{OB}</td>
                     <td>{OR}</td>
                     <td>{MPR}</td>
                     <td>{MPB}</td>
                     <td>{IPR}</td>
                     <td>{IPB}</td>
                     <td className="pr-1 text-bold">{total}</td>
                  </tr>
               )
            }
         </tbody>
         <tfoot>
            <tr className="text-right text-bold">
               <td className="pl-2">{tablaTotales[0]}</td>
               <td>{tablaTotales[1]}</td>
               <td>{tablaTotales[2]}</td>
               <td>{tablaTotales[3]}</td>
               <td>{tablaTotales[4]}</td>
               <td>{tablaTotales[5]}</td>
               <td>{tablaTotales[6]}</td>
               <td className="pr-2">{tablaTotales[7]}</td>
            </tr>
         </tfoot>
      </table>
   )
}

export default TablaEquipamiento